{% block swag_migration_settings_icon %}
    <img
        class="swag-migration-settings_icon__img"
        :src="assetFilter('/swagmigrationassistant/administration/static/img/migration-assistant-plugin.svg')"
        alt=""
    >
{% endblock %}
